import { Either, Option } from 'funfix-core';
import { FINISH_GENERATE_APP_SPECIFIC_PASSWORD, FINISH_REGENERATE_APP_SPECIFIC_PASSWORD, GENERATE_APP_SPECIFIC_PASSWORD_ERROR, REGENERATE_APP_SPECIFIC_PASSWORD_ERROR, SET_APP_SPECIFIC_PASSWORD_NAME, START_GENERATE_APP_SPECIFIC_PASSWORD, START_REGENERATE_APP_SPECIFIC_PASSWORD } from '../../../actions/Installation/InstallMode/AppSpecificPassword';
import { makeAppSpecificPassword, makeAppSpecificPasswordInstallMode } from '../../../records/InstallMode/AppSpecificPasswordInstallMode';
import { foldInstallMode } from '../../../records/InstallMode/InstallMode';
import { makeCompleteInstallStatus, makeInProgressInstallStatus } from '../../../records/InstallMode/InstallStatus';
import { mapInstallMode } from '../InstallationUtils';
const appSpecificPasswordReducer = (state, action) => {
  switch (action.type) {
    case SET_APP_SPECIFIC_PASSWORD_NAME:
      {
        const name = action.name;
        return mapInstallMode(state, currentInstallMode => foldInstallMode(currentInstallMode)(value => value, asp => asp.set('appSpecificPassword', name ? makeAppSpecificPassword({
          name
        }) : null), value => value, value => value, value => value, value => value));
      }
    case START_GENERATE_APP_SPECIFIC_PASSWORD:
      return mapInstallMode(state, currentInstallMode => foldInstallMode(currentInstallMode)(value => value, asp => asp.update('appSpecificPassword', oast => oast.map(ast => ast.set('status', makeInProgressInstallStatus()))), value => value, value => value, value => value, value => value));
    case START_REGENERATE_APP_SPECIFIC_PASSWORD:
      return state.set('installMode', Option.some(makeAppSpecificPasswordInstallMode({
        appSpecificPassword: Option.some(makeAppSpecificPassword({
          name: action.name,
          status: makeInProgressInstallStatus()
        }))
      })));
    case FINISH_GENERATE_APP_SPECIFIC_PASSWORD:
    case FINISH_REGENERATE_APP_SPECIFIC_PASSWORD:
      {
        const generatedAppSpecificPassword = action.generatedAppSpecificPassword;
        return mapInstallMode(state, currentInstallMode => foldInstallMode(currentInstallMode)(value => value, asp => asp.update('appSpecificPassword', oast => oast.map(ast => ast.set('status', makeCompleteInstallStatus({
          result: Either.right(generatedAppSpecificPassword)
        })))), value => value, value => value, value => value, value => value));
      }
    case GENERATE_APP_SPECIFIC_PASSWORD_ERROR:
    case REGENERATE_APP_SPECIFIC_PASSWORD_ERROR:
      {
        const error = action.error;
        return mapInstallMode(state, currentInstallMode => foldInstallMode(currentInstallMode)(value => value, asp => asp.update('appSpecificPassword', oast => oast.map(ast => ast.set('status', makeCompleteInstallStatus({
          result: Either.left(error)
        })))), value => value, value => value, value => value, value => value));
      }
    default:
      // Flow compile-time validation that we've handled every action
      // prettier-ignore
      action;
      return state;
  }
};
export default appSpecificPasswordReducer;